module.exports = __webpack_public_path__ + "8fbec967efd05006901c0b8028d4496c.png";